import React, { useEffect, useState } from "react";
import api from "../api";

const SummaryCard = ({ period }) => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await api.get(`/Dashboard/sales-summary/${period.toLowerCase()}`);
        const data = response.data;

        setStats({
          totalSales: data.totalRevenue ?? 0,
          totalOrders: data.totalOrders ?? 0,
          topProducts: data.topProducts ?? [],
          activeCustomers: (data.topProducts ?? []).length
        });
      } catch (err) {
        console.error("Error fetching summary:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [period]);

  if (loading) return <div>Loading...</div>;
  if (!stats) return <div>No data available</div>;

  return (
    <>
      <style>{`
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
          gap: 16px;
          margin: 20px 0;
        }
        .stat-card {
          
          background: #fff;
          border-radius: 10px;
          padding: 16px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.08);
        }
        .stat-icon { font-size: 28px; margin-bottom: 8px; }
         
        .stat-number { font-size: 60px; font-weight: bold; margin-bottom: 4px; }
        .stat-label { font-size: 20px; color: #666; font-weight: bold; }
        .top-products-table { width: 100%; border-collapse: collapse; margin-top: 10px; }
        .top-products-table th, .top-products-table td {
          border: 1px solid #ddd; padding: 6px 8px; text-align: left;
        }
        .top-products-table th { background-color: #f4f4f4; font-weight: 600; }
        .stat-inline {
  display: flex;
  align-items: center;
  gap: 8px;
}
      `}</style>

      <div className="stats-grid">
        <div className="stat-card">
           <div className="stat-inline">
  <div className="stat-icon">💰</div>
  <div className="stat-label">Total Revenue</div>
</div>
          
          <div className="stat-number">₹{stats.totalSales.toLocaleString()}</div>
          
        </div>

        <div className="stat-card">
         <div className="stat-inline">
  <div className="stat-icon">📦</div>
  <div className="stat-label">Total Orders</div>
</div>
 <div className="stat-number">{stats.totalOrders}</div>
         
        </div>

        <div className="stat-card">
         
          <div className="stat-inline">
  <div className="stat-icon">🍔</div>
  <div className="stat-label">Top Products</div>
</div>
         
          <table className="top-products-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Qty</th>
                <th>Revenue</th>
              </tr>
            </thead>
            <tbody>
              {stats.topProducts.slice(0, 3).map((p, idx) => (
                <tr key={idx}>
                  <td>{p.product.trim()}</td>
                  <td>{p.quantity}</td>
                  <td>₹{p.revenue}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

       
      </div>
    </>
  );
};

export default SummaryCard;